import React from 'react'
import { ContainerNew } from '../../../dashboard/pages/home-new/styled'
import TableSerial from '../../components/tailwind/table-serial'

const Serials = () => {

    //const dispatch = useDispatch()
    //const { id } = useParams();

   


    return (

        <ContainerNew>
            <TableSerial
            //products={products}
            //order={order?.data?.data?.order_number}
            />
        </ContainerNew>
    )
}

export default Serials